import type { DropdownProps, MenuProps } from 'antd'
import { Dropdown } from 'antd'

import MenuIcon from '@/assets/icons/accountDetail.svg?react'
import { cn } from '@/utils/style'

export interface ActionMenuItem {
  label: React.ReactNode
  onClick: () => void
  type?: 'default' | 'danger' | 'highlight'
  show?: boolean
  disabled?: boolean
}

export interface ActionMenuProps {
  items: ActionMenuItem[]
  iconClassName?: string
  popupContainer?: 'self' | 'body' | HTMLElement
  icon?: React.ReactNode
  placement?: DropdownProps['placement']
  trigger?: 'click' | 'hover'
}

export function ActionMenu({
  items,
  iconClassName,
  popupContainer = 'self',
  icon,
  placement = 'bottomLeft',
  trigger = 'click',
}: ActionMenuProps) {
  // Filter visible items
  const visibleItems = items.filter((item) => item.show !== false)

  // Don't render if no visible items
  if (visibleItems.length === 0) {
    return null
  }

  // Convert ActionMenuItem[] to Ant Design MenuProps['items']
  const menuItems: MenuProps['items'] = visibleItems.map((item, index) => ({
    key: index,
    label: item.label,
    disabled: item.disabled,
    className: cn('!t-sm !px-3 !py-2', {
      '!text-primary': item.type === 'highlight',
      '!text-error': item.type === 'danger' && !item.disabled,
    }),
    onClick: () => !item.disabled && item.onClick(),
  }))
  const getContainer = (node: HTMLElement) => {
    if (popupContainer === 'body') return document.body
    if (popupContainer instanceof HTMLElement) return popupContainer
    return node
  }

  return (
    <>
      <span className="relative inline-block z-10" onClick={(e) => e.stopPropagation()}>
        <Dropdown
          trigger={[trigger]}
          placement={placement}
          menu={{ items: menuItems, onClick: ({ domEvent }) => domEvent.stopPropagation() }}
          overlayClassName="p-1 !min-w-[150px] !w-auto !z-[9999]"
          autoAdjustOverflow
          getPopupContainer={getContainer}
          overlayStyle={{ zIndex: 9999 }}
        >
          <div onClick={(e) => e.stopPropagation()}>
            {icon ?? <MenuIcon className={cn('cursor-pointer w-4 h-4', iconClassName)} />}
          </div>
        </Dropdown>
      </span>
    </>
  )
}
